import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Container = styled.div`
  box-sizing: border-box;
  ${props => {
    const size = props.size || 24;
    const padding = props.padding || 4;
    return (`
      padding: ${padding}px;
      height: ${size}px;
      width: ${size}px;
      min-height: ${size}px;
      min-width: ${size}px;
    `);
  }}

  justify-content: center;
  align-items: center;
  color: ${props => props.color ? props.color : '#626469'};
  border: 1px solid ${props => props.color ? props.color : '#626469'};
  border-radius: 2px;
  cursor: pointer;
  overflow-clip-margin: content-box;
  ${props => props.disabled ? `opacity: 0.75; pointer-events: none;` : ``}
  margin-left: 5px;
`;

class IconButton extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    color: PropTypes.string,
    size: PropTypes.number,
    padding: PropTypes.number
  };

  renderIcon = () => {
    let icon = <></>;

    switch (this.props.icon) {
      case 'edit':
        icon = (<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 1024 1024"><path fill="currentColor" d="M837 187c45 44 66 107 56 169-1 4-3 8-6 11L387 866c-4 6-10 9-16 10l-121 12h-5l-94 9h-2c-6 0-12-2-16-6-4-5-6-11-6-17l21-220c1-7 4-13 10-17l499-500c3-3 7-5 12-6 60-10 122 10 165 53zm-155-14L231 625c29 5 56 23 73 50 2 3 4 6 5 10l482-482c-31-24-70-35-109-30zm170 169c4-39-7-78-31-108L340 714l12 7c26 17 43 43 48 72zM354 835c11-28 1-61-25-77-9-6-21-10-32-10h-1c-10-1-19-9-19-19v-2c-1-10-4-21-10-30-16-27-49-38-78-27l-9 92c39 12 69 43 81 82zm-178-29l-4 46 46-4c-8-19-23-34-42-42z"/></svg>)
        break;
      case 'remove':
        icon = (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path fill="currentColor" d="M840 232c12 0 21 9 21 21v104c0 11-9 21-21 21h-48v421c0 54-44 97-97 97H329c-26 0-50-10-68-28-19-18-29-43-29-69V378h-48c-12 0-21-10-21-21V253c0-12 9-21 21-21h186v-83c0-11 9-21 21-21h242c12 0 21 10 21 21v83h186zm-427-61v61h198v-61H413zm406 164v-61H205v61h614zm-69 464V378H274v421c0 15 6 28 17 39 10 10 23 15 38 15h366c31-1 54-24 55-54zm-359-7c-12 0-21-9-21-21V460c0-11 9-21 21-21s22 10 22 21v311c0 12-10 21-22 21zm121 0c-12 0-21-9-21-21V460c0-11 9-21 21-21s21 10 21 21v311c0 12-9 21-21 21zm121 0c-12 0-22-9-22-21V460c0-11 10-21 22-21s21 10 21 21v311c0 12-9 21-21 21z"/></svg>);
        break;
      default:
        break;
    }

    return icon;
  }


  render = () => {
    const idProps = {};
    if (this.props.id) {
      idProps['id'] = this.props.id;
    }

    return (
      <Container {...idProps} size={this.props.size} color={this.props.color} onClick={() => {
        this.props.onClick();
      }} disabled={this.props.disabled} padding={this.props.padding}>
        {this.renderIcon()}
      </Container>
    );
  };
}

export default IconButton;
